import { type RouteObject } from 'react-router';

export const FINANCE_NESTED_ROUTES: Record<string, RouteObject> = {
  'finance/overview': {
    path: 'finance/overview',
    lazy: () => import('./routes/finance/overview/route').then((m) => ({ Component: m.default })),
  },
  'finance/gmv': {
    path: 'finance/gmv',
    lazy: () => import('./routes/finance/gmv/route').then((m) => ({ Component: m.default })),
  },
  'finance/cash-availability': {
    path: 'finance/cash-availability',
    lazy: () =>
      import('./routes/finance/cash-availability/route').then((m) => ({ Component: m.default })),
  },
  'finance/cash-flow': {
    path: 'finance/cash-flow',
    lazy: () => import('./routes/finance/cash-flow/route').then((m) => ({ Component: m.default })),
  },
  'finance/payments-ledger': {
    path: 'finance/payments-ledger',
    lazy: () =>
      import('./routes/finance/payments-ledger/route').then((m) => ({ Component: m.default })),
  },
  'finance/goods-in-transit': {
    path: 'finance/goods-in-transit',
    lazy: () =>
      import('./routes/finance/goods-in-transit/route').then((m) => ({ Component: m.default })),
  },
  'finance/eligibility': {
    path: 'finance/eligibility',
    lazy: () =>
      import('./routes/finance/eligibility/route').then((m) => ({ Component: m.default })),
  },
  'finance/data-tape': {
    path: 'finance/data-tape',
    lazy: () =>
      import('./features/data-tape/routes/data-tape-page').then((m) => ({ Component: m.default })),
  },
  'finance/data-tape-new': {
    path: 'finance/data-tape-new',
    lazy: () =>
      import('./features/data-tape/v2/routes/data-tape-v2-page').then((m) => ({
        Component: m.default,
      })),
  },
  // Routes derive from the sidebar (route-tree.tsx maps NAV_GROUPS items to
  // NESTED_ROUTES[item.slug]), so a key with no nav entry is never registered.
  // Children are how sub-routes reach the router — same shape as `companies`.
  'finance/data-tape-new/declarations': {
    path: 'finance/data-tape-new/declarations',
    children: [
      {
        index: true,
        lazy: () =>
          import('./features/data-tape/v2/routes/declarations-list-page').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: 'new',
        lazy: () =>
          import('./features/data-tape/v2/routes/declarations-page').then((m) => ({
            Component: m.default,
          })),
      },
      {
        path: ':declarationId',
        lazy: () =>
          import('./features/data-tape/v2/routes/declaration-detail-page').then((m) => ({
            Component: m.default,
          })),
      },
    ],
  },
  // Unregistered since its nav entry was removed (10 Aug). Kept so re-adding that
  // entry restores the old surface; B3.28 deletes both.
  'finance/data-tape-new/submissions': {
    path: 'finance/data-tape-new/submissions',
    lazy: () =>
      import('./features/data-tape/v2/routes/submissions-page').then((m) => ({
        Component: m.default,
      })),
  },
  'finance/concentration-caps': {
    path: 'finance/concentration-caps',
    lazy: () =>
      import('./features/data-tape/caps/routes/concentration-caps-page').then((m) => ({
        Component: m.default,
      })),
  },
  'finance/cash-balances': {
    path: 'finance/cash-balances',
    lazy: () =>
      import('./routes/finance/cash-balances/route').then((m) => ({ Component: m.default })),
  },
  'finance/transactions': {
    path: 'finance/transactions',
    lazy: () =>
      import('./routes/finance/transactions/route').then((m) => ({ Component: m.default })),
  },
};
